import { isApiError } from "./errors";

export const describeError = (error: unknown): string => {
  if (isApiError(error)) return `${error.message} (request ${error.requestId})`;
  if (error instanceof Error) return error.message;
  return "An unexpected problem stopped this page from loading.";
};
